<div class="user-details-page-container">
  <ng-container>
    <company-user-info-card></company-user-info-card>
  </ng-container>

  <div class="user-details-page-container__password">
    <company-block-card
      [title]="'LABELS.SIGN_IN_INFO'"
      [hint]="(isTablet$ | async) && 'LABELS.EDIT_PASSWORD_DESCRIPTION'"
      [explanationSubTitle]="isChangePassword && 'BUTTON.CHANGE_PASSWORD'"
      [isMarginBottom]="true"
    >
      <ng-container card-actions>
        <div *ngIf="!isChangePassword" class="header-container__actions ml-3" (click)="changeIsChangePasswordState()">
          <img src="assets/icons/edit_gray.svg" />
          <span *ngIf="!(isTablet$ | async)">{{ "BUTTON.CHANGE_PASSWORD" | translate }}</span>
        </div>
      </ng-container>

      <ng-container card-body>
        <div class="info-container" *ngIf="!isChangePassword; else editPassword">
          <div class="info-container__item">
            <span class="label">{{ "LABELS.PASSWORD" | translate }}</span>
            <span class="value">*********</span>
          </div>
        </div>
      </ng-container>
    </company-block-card>
  </div>

  <div class="user-details-page-container__login-attempts">
    <company-block-card
      [title]="'COMPANY.LOGIN_HISTORY'"
      [hint]="(isTablet$ | async) && 'LABELS.LOGIN_ATTEMPTS_DESCRIPTION'"
      [isMarginBottom]="true"
    >
      <ng-container card-actions>
        <div class="header-container__actions ml-3" (click)="isShowLoginAttemptsList = !isShowLoginAttemptsList">
          <span class="pr-2" *ngIf="!(isTablet$ | async)">
            {{ (!isShowLoginAttemptsList ? "BUTTON.SEE_MORE" : "BUTTON.CLOSE") | translate }}
          </span>
          <img src="assets/icons/icon_chevron_up.svg" [ngClass]="{ 'is-open': !isShowLoginAttemptsList }" />
        </div>
      </ng-container>

      <ng-container card-body>
        <div class="attempts-container" *ngIf="!isShowLoginAttemptsList; else loginAttemptsList">
          <div class="col-12 col-lg-8 pl-0 d-flex align-items-center">
            <span class="attempts-container__label">{{ "LABELS.LAST_SIGN_IN" | translate }}</span>
            <span class="attempts-container__value" *ngIf="loginAttempts$ | async as loginAttempts">
              {{ loginAttempts[0]?.timestamp | customDateByUtc }}
            </span>
          </div>
          <div class="d-none d-lg-block col-4 pr-0">
            <div class="attempts-container__description">
              {{ "LABELS.LOGIN_ATTEMPTS_DESCRIPTION" | translate }}
            </div>
          </div>
        </div>
      </ng-container>
    </company-block-card>
  </div>

  <!--  #7996-->
  <div class="user-details-page-container__delete-account">
    <company-block-card [title]="'LABELS.DELETE_ACCOUNT'">
      <ng-container card-body>
        <div class="content-container flex-column flex-lg-row">
          <div class="col-12 col-lg-7 pl-0">
            <span class="content-container__label">
              {{ "LABELS.DEACTIVATE_ACCOUNT_DESCRIPTION_FIRST" | translate }}
            </span>
            <span class="content-container__label">
              {{ "LABELS.DEACTIVATE_ACCOUNT_DESCRIPTION_SECOND" | translate }}
            </span>
          </div>
          <div class="d-flex col-12 col-lg-3 justify-content-center justify-content-lg-end pt-3 pt-lg-0 pr-0">
            <div class="content-container__delete-button" (click)="openDeactivateAccountModal()">
              {{ "BUTTON.DEACTIVATE_ACCOUNT" | translate }}
            </div>
          </div>
        </div>
      </ng-container>
    </company-block-card>
  </div>
</div>

<ng-template #editPassword>
  <form [formGroup]="passwordFormGroup" class="password-form">
    <div class="password-form-block">
      <div class="d-flex flex-column col-12 col-lg-8 p-0">
        <div class="form-row">
          <div class="col-12" id="control-oldPassword">
            <!-- oldPassword -->
            <app-password-input
              [fc]="passwordFormGroup.get('oldPassword')"
              [label]="'FORM_LABEL.CURRENT_PASSWORD'"
              [id]="'oldPassword'"
            ></app-password-input>
          </div>
        </div>
        <div class="form-row">
          <!-- new-password -->
          <div class="col-12">
            <app-password-input
              [fc]="passwordFormGroup.get('password')"
              [label]="'FORM_LABEL.NEW_PASSWORD'"
              [id]="'password'"
            ></app-password-input>
          </div>
        </div>
        <div class="form-row password-labels" *ngIf="passwordFormGroup.get('password').dirty">
          <div class="form-group">
            <div *ngFor="let p of passwordLabels">
              <i [ngClass]="{ 'icon-ic_close': p.isError, 'icon-ic_Check': !p.isError }"></i>
              <span>{{ "FORM_LABEL." + p.text | translate }}</span>
            </div>
          </div>
        </div>
        <div class="form-row">
          <!-- confirmPassword -->
          <div class="col-12">
            <app-password-input
              [fc]="passwordFormGroup.get('confirmPassword')"
              [label]="'FORM_LABEL.CONFIRM_PASSWORD'"
              [errors]="confirmPasswordErrors"
              [id]="'confirmPassword'"
            ></app-password-input>
          </div>
        </div>
      </div>
      <div class="d-none d-lg-block col-4 pr-0">
        <div class="password-form-block__description">
          {{ "LABELS.EDIT_PASSWORD_DESCRIPTION" | translate }}
        </div>
      </div>
    </div>

    <div class="password-form-actions">
      <button
        type="button"
        class="password-form-actions__button password-form-actions__button-secondary"
        (click)="changeIsChangePasswordState()"
      >
        {{ "BUTTON.CANCEL" | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary password-form-actions__button password-form-actions__button-primary"
        (click)="changePassword()"
        [disabled]="passwordFormGroup.invalid || isAnyPasswordRuleInvalid"
      >
        {{ "BUTTON.CHANGE_PASSWORD" | translate }}
      </button>
    </div>
  </form>
</ng-template>

<ng-template #loginAttemptsList>
  <div class="attempts-container">
    <div class="col-12 col-lg-8 pl-0 d-flex flex-column">
      <div class="d-flex pb-2" *ngFor="let item of loginAttempts$ | async">
        <span class="attempts-container__label">{{ item.timestamp | date }}</span>
        <span class="attempts-container__value">{{ item.ipAddress }}</span>
      </div>
    </div>
    <div class="d-none d-lg-block col-4 pr-0">
      <div class="attempts-container__description">
        {{ "LABELS.LOGIN_ATTEMPTS_DESCRIPTION" | translate }}
      </div>
    </div>
  </div>
</ng-template>

<custom-modal
  [header]="(blockOptions?.canUserBeBlocked ? 'CANCEL_ACCOUNT.ARE_YOU_SURE' : 'CANCEL_ACCOUNT.MODAL_HEADER') | translate"
  [(open)]="isDeactivateAccount"
>
  <div *ngIf="blockOptions?.userHasCustoms" [innerHTML]="'CANCEL_ACCOUNT.CAN_NOT_CANCEL_ACCOUNT_MESSAGE' | translate"></div>
  <div
    *ngIf="blockOptions?.userHasShipments && !blockOptions?.userHasCustoms"
    [innerHTML]="'CANCEL_ACCOUNT.CAN_NOT_CANCEL_ACCOUNT_SHIPMENT' | translate"
  ></div>
  <div *ngIf="blockOptions?.canUserBeBlocked">
    <span [innerHTML]="'LABELS.DEACTIVATE_ACCOUNT_DESCRIPTION_SECOND' | translate"></span>
    <div class="pt-3">
      <app-control-wrapper [control]="deletionReasonControl">
        <label for="deletionReason" control-label>
          {{ "CANCEL_ACCOUNT.WHY_ARE_YOU_CANCELING_YOUR_ACCOUNT" | translate }}
        </label>
        <textarea
          type="text"
          [rows]="4"
          [formControl]="deletionReasonControl"
          class="form-control"
          id="deletionReason"
          name="deletionReason"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [mask]="'F*'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          control-wrapper
        ></textarea>
      </app-control-wrapper>
    </div>
  </div>

  <button footer-action type="button" class="btn btn-primary" (click)="cancelAccount()" *ngIf="blockOptions?.canUserBeBlocked">
    {{ "BUTTON.OK" | translate }}
  </button>
  <button footer-action type="button" class="btn btn-secondary" (click)="isDeactivateAccount = false">
    {{ "BUTTON.CANCEL" | translate }}
  </button>
</custom-modal>
